import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import ScrollReveal from "scrollreveal"

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

      //SPメニューの高さ取得
    function menuHight() {
        var win = $(window).innerWidth();
        if (win > 750) {
            return false;
        }

        var $smpHeaderHeight = $('.l-header').height();
        var windowHeight = window.innerHeight;
        var winH = windowHeight - $smpHeaderHeight;

        console.log($smpHeaderHeight);

        //動かすターゲットを取得
        var targetSlidebarWrap = $('.c-slidebar-menu'),
            targetSlidebarMenu = $('.c-slidebar__parent'),
            targetSlidebarBtn = $('.c-slidebar-menu__parent');


        //いざ実行(クリックしたら処理を実行する)
        targetSlidebarBtn.on('click', function () {
            $('.c-slidebar-menu').toggleClass('is-active');

        });
    }

      //フッターメニューSPスライド
      function menuSlide() {
          var win = $(window).innerWidth();
          if (win > 750) {
              return false;
          }
          $('.l-footer__block').on('click',function() {
              $(this).children(".l-footer__menutitle").toggleClass('is-open');
              $(this).children(".l-footer__menulist.is-sub").slideToggle();
          })
      }

      //owlcarousel
      function owlCarousel() {
          var owls = $('.owl-carousel');
          if (owls.length === 0) {
              return false
          }
          //->スライダー
          owls.imagesLoaded(function () {
              $('.c-main-visual__slider').owlCarousel({
                  items: 1,
                  margin: 0,
                  dots: true,
                  loop: true,
                  nav: false,
                  autoplayHoverPause: true,
                  autoplay: true,
                  autoplaySpeed: 500,
                  autoWidth: false,
                  autoHeight: false,
                  center: true,
                  navText: ['<img src="/wp-content/themes/arcoinc-html/dist/assets/images/icon-slider-prev.svg" />','<img src="/wp-content/themes/arcoinc-html/dist/assets/images/icon-slider-next.svg" />'],
              });
          });
          //->カルーセル
          owls.imagesLoaded(function () {
              $('.c-main-visual__carousel').owlCarousel({
                  items: 1,
                  margin: 16,
                  dots: true,
                  loop: true,
                  nav: true,
                  autoplayHoverPause: true,
                  autoplay: false,
                  autoplaySpeed: 500,
                  autoWidth: false,
                  autoHeight: false,
                  center: true,
                  navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>','<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
                  responsive : {
                    // breakpoint from 0 up
                    0 : {
                      stagePadding: 32,
                    },
                    // breakpoint from 750  up
                    750 : {
                      stagePadding: 64,
                    },
                    // breakpoint from 950 up
                    950 : {
                      stagePadding: 156,
                    },
                    1400 : {
                      stagePadding: 312,
                    }
                  }
              });
          });
          //->カルーセル_ノーマル
          owls.imagesLoaded(function () {
          $('.c-main-visual__carousel.is-normal').owlCarousel({
            items: 1,
            margin: 8,
            dots: true,
            loop: true,
            nav: true,
            autoplayHoverPause: true,
            autoplay: false,
            autoplaySpeed: 500,
            autoWidth: false,
            autoHeight: false,
            center: true,
            navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>','<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
            responsive : {
              // breakpoint from 0 up
              0 : {
                stagePadding: 32,
              },
              // breakpoint from 750  up
              750 : {
                stagePadding: 64,
              },
              // breakpoint from 950 up
              950 : {
                stagePadding: 156,
              },
              1400 : {
                stagePadding: 312,
              }
            }
          });
        });
          //->カルーセル_レイヤー
          owls.imagesLoaded(function () {
            $('.c-block-tag__button').owlCarousel({
              items: 3,
              margin: 0,
              dots: false,
              loop: false,
              nav: true,
              autoplayHoverPause: true,
              autoplay: false,
              autoplaySpeed: 500,
              autoWidth: false,
              autoHeight: false,
              center: false,
              navText: ['<img src="/wp-content/themes/arcoinc-html/dist/assets/images/icon-slider-arrow-prev.svg" />','<img src="/wp-content/themes/arcoinc-html/dist/assets/images/icon-slider-arrow-next.svg" />'],
            });
          });
          //->カード_カルーセル
          owls.imagesLoaded(function () {
              $('.js-card-slider').owlCarousel({
                  dots: false,
                  loop: true,
                  nav: true,
                  autoplayHoverPause: true,
                  autoplay: true,
                  autoplaySpeed: 500,
                  autoWidth: false,
                  autoHeight: false,
                  center: false,
                  margin: 0,
                  navText: ['<img src="/wp-content/themes/arcoinc-html/dist/assets/images/icon-slider-arrow-prev.svg" />','<img src="/wp-content/themes/arcoinc-html/dist/assets/images/icon-slider-arrow-next.svg" />'],
                  responsive : {
                    // breakpoint from 0 up
                    0 : {
                      items: 2,
                      stagePadding: 35,
                    },
                    // breakpoint from 750 up
                    750 : {
                      items: 3,
                      stagePadding: 0,
                    },
                    // breakpoint from 750 up
                    1140 : {
                      items: 4,
                      stagePadding: 0,
                    }
                  }
              });
            $('.js-card-slider-mbs').owlCarousel({
              dots: false,
              loop: true,
              nav: true,
              autoplayHoverPause: true,
              autoplay: true,
              autoplaySpeed: 500,
              autoWidth: false,
              autoHeight: false,
              center: false,
              navText: ['<img src="/wp-content/themes/arcoinc-html/dist/assets/images/icon-slider-arrow-prev.svg" />','<img src="/wp-content/themes/arcoinc-html/dist/assets/images/icon-slider-arrow-next.svg" />'],
              responsive : {
                // breakpoint from 0 up
                0 : {
                  items: 2,
                  stagePadding: 35,
                  margin: 8,
                },
                // breakpoint from 750 up
                750 : {
                  items: 3,
                  stagePadding: 0,
                  margin: 40,
                },
                // breakpoint from 750 up
                1140 : {
                  items: 4,
                  stagePadding: 0,
                  margin: 40,
                }
              }
            });
          });
      }
    function scrollReveal() {
      //- スクロールリーバル
      window.sr = ScrollReveal({duration: 600});

      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }
      sr.reveal("#mainVisual", {
        scale: 1,
        delay: 200,
        opacity: 0,
        duration: 1000,
        distance: '0'
      }, 100);
      sr.reveal(".l-main.is-lower,.c-main-visual-pickup", {
        scale: 1,
        delay: 200,
        opacity: 0,
        duration: 900,
        origin: 'bottom',
        distance: '12px'
      }, 100);
      sr.reveal(".c-main-visual-pickup__arrow", {
        scale: 1,
        delay: 800,
        opacity: 0,
        duration: 900,
        origin: 'bottom',
        distance: '-12px'
      }, 100);
      sr.reveal(".l-section.is-top-padding .l-container-lg", {
        scale: 1,
        delay: 0,
        opacity: 0,
        duration: 600,
        distance: '0',
        reset: true,
        viewFactor: 0.2,
      }, 100);
      var blocks01 = $(".c-block-images");
      domEach(blocks01, function (key, item) {
        sr.reveal(item, {scale: 1, duration: 900, delay: 100, origin: 'bottom', distance: '16px'}, 200);
        sr.reveal(item.children[0], { duration: 900, delay: 200, origin: 'bottom', distance: '16px'}, 200);
        sr.reveal(item.children[1], { duration: 900, delay: 300, origin: 'bottom', distance: '16px'}, 200);
        sr.reveal(item.children[2], { duration: 900, delay: 400, origin: 'bottom', distance: '16px'}, 200);
        sr.reveal(item.children[3], { duration: 900, delay: 500, origin: 'bottom', distance: '16px'}, 200);
        sr.reveal(item.children[4], { duration: 900, delay: 600, origin: 'bottom', distance: '16px'}, 200);
        sr.reveal(item.children[5], { duration: 900, delay: 700, origin: 'bottom', distance: '16px'}, 200);
        sr.reveal(item.children[6], { duration: 900, delay: 800, origin: 'bottom', distance: '16px'}, 200);
        sr.reveal(item.children[7], { duration: 900, delay: 900, origin: 'bottom', distance: '16px'}, 200);
      });
    }

      function blur() {
        $('.l-block-bgimage.is-events').each(function(i, elem){
          var contentsPOS = $(elem).offset().top;
          $(window).on('load scroll resize', function(){
            var winHeight = $(window).height();
            var scrollTop = $(window).scrollTop();
            var showClass = 'is-active';
            var timing = 100;
            if (scrollTop >= contentsPOS - winHeight + timing){
              $(elem).addClass(showClass);
            } else {
              $(elem).removeClass(showClass);
            }
          });
        });
      }

    function addClass() {


    }

    function parallax() {
      var owls = $('#parallax-01');
      if (owls.length === 0) {
        return false
      }
      var win = $(window).innerWidth();
      if (win < 750) {
        return false;
      }
      var target1 = $("#parallax-01");
      var targetPosOT1 = target1.offset().top;
      var target2 = $("#parallax-02");
      var targetPosOT2 = target2.offset().top;
      var target3 = $("#parallax-03");
      var targetPosOT3 = target3.offset().top;
      var target4 = $("#parallax-04");
      var targetPosOT4 = target4.offset().top;
      var target5 = $("#parallax-05");
      var targetPosOT5 = target5.offset().top;
      var targetFactor = 0.5;
      var windowH = $(window).height();
      var scrollYStart1 = targetPosOT1 - windowH;
      var scrollYStart2 = targetPosOT2 - windowH;
      var scrollYStart3 = targetPosOT3 - windowH;
      var scrollYStart4 = targetPosOT4 - windowH;
      var scrollYStart5 = targetPosOT5 - windowH;
      $(window).on('scroll',function(){
        var scrollY = $(this).scrollTop();
        if(scrollY > scrollYStart1){
          target1.css('background-position-y', (scrollY - targetPosOT1) * targetFactor + 'px');
        }else{
          target1.css('background-position','center top');
        }
        if(scrollY > scrollYStart2){
          target2.css('background-position-y', (scrollY - targetPosOT2) * targetFactor + 'px');
        }else{
          target2.css('background-position','center top');
        }
        if(scrollY > scrollYStart3){
          target3.css('background-position-y', (scrollY - targetPosOT3) * targetFactor + 'px');
        }else{
          target3.css('background-position','center top');
        }
        if(scrollY > scrollYStart4){
          target4.css('background-position-y', (scrollY - targetPosOT4) * targetFactor + 'px');
        }else{
          target4.css('background-position','center top');
        }
        if(scrollY > scrollYStart5){
          target5.css('background-position-y', (scrollY - targetPosOT5) * targetFactor + 'px');
        }else{
          target5.css('background-position','center top');
        }
      });
    }

    $(function() {
        //menuSlide();
        owlCarousel();
        blur();
        scrollReveal();
        addClass();
        //parallax();
        scroll();
    });
  }
}

window.GApp = new App();
